import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import imagen1 from '../img/get_view1.jpg';
import Sidebar from '../componenteExtra/SidebarLider';
import { FaClock, FaClipboardList } from 'react-icons/fa';
import Footer from '../componenteExtra/Footer';
import NotificationBellLider from '../notificaciones/NotificationBellLider'; // Importar el nuevo componente
import SessionManager from '../componenteExtra/SessionManager';

const MenuLider = () => {
    const navigate = useNavigate();
    const [nombre, setNombre] = useState('');
    const [grupo, setGrupo] = useState('');

    useEffect(() => {
        // Obtener el nombre y grupo del localStorage
        const storedNombre = localStorage.getItem('nombre_get');
        const storedGrupo = localStorage.getItem('grupo');
        if (storedNombre) setNombre(storedNombre);
        if (storedGrupo) setGrupo(storedGrupo);
    }, []);

    return (
        <div className="app">
            <SessionManager />
            <div className="main-content">
                <Sidebar />
                <div className="main-panel">
                    <div className="welcome-message">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "20px 0",
                                width: "100%",
                                marginBottom: "10px",
                            }}
                        >
                            <h2 style={{ margin: 0, lineHeight: 1 }}>
                                Bienvenido(a) Líder/Subrogante Grupo {grupo} - {nombre}
                            </h2>
                            {grupo && <NotificationBellLider />}
                        </div>
                        <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div className="cards-container">
                        <div className="card">
                            <div className="card-header">
                                <FaClipboardList />
                                <h3>Solicitudes en espera de documentación</h3>
                            </div>
                            <div className="card-subtitle">Acceso Directo</div>
                            <div className="card-content">
                                Este módulo se verán las solicitudes ingresadas por el senior que están sin documentar.
                            </div>
                            <button onClick={() => navigate('/ActividadesSinDocumentar')}>Ir a ver Solicitudes en espera</button>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                <FaClock />
                                <h3>Solicitudes en espera de asignación</h3>
                            </div>
                            <div className="card-subtitle">Acceso Directo</div>
                            <div className="card-content">
                                Este módulo se verán las solicitudes que se pueden asignar a sus asistentes.
                            </div>
                            <button onClick={() => navigate('/AsignarStaff')}>Ir a Asignar Actividades</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MenuLider;